export const PaymentType = Object.freeze({
    APPLE_PAY: "Apple Pay",
    CREDIT_CARD: "Credit Card",
});
